/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import AdobeAdvertisingCloud from '@react/react-spectrum/Icon/AdobeAdvertisingCloud';
import AdobeAnalytics from '@react/react-spectrum/Icon/AdobeAnalyticsColorDark';
import AdobeAudienceManager from '@react/react-spectrum/Icon/AdobeAudienceManagerColorDark';
import AdobeCampaign from '@react/react-spectrum/Icon/AdobeCampaignColorDark';
import AdobeExperienceManager from '@react/react-spectrum/Icon/AdobeExperienceManagerColorDark';
import AdobeMediaOptimizer from '@react/react-spectrum/Icon/AdobeMediaOptimizerColorDark';
import AdobePrimetime from '@react/react-spectrum/Icon/AdobePrimetime';
import AdobeTarget from '@react/react-spectrum/Icon/AdobeTargetColorDark';
import Icon from '@react/react-spectrum/Icon';
import React from 'react';

// Workaround until color version of AdobeExperienceCloud Icon is available
/* eslint-disable max-len */
const AdobeExperienceCloud = (props) => {
  return (
    <Icon {...props}>
      <svg id="Layer_1" style={{enableBackground: 'new 0 0 24 24'}} version="1.1" viewBox="0 0 24 24" x="0px" xmlns="http://www.w3.org/2000/svg" y="0px">
        <g id="experiencecloud">
          <radialGradient cx="153.5857" cy="-1067.0081" gradientTransform="matrix(0.952 0 0 -0.977 -136.859 -1044.35)" gradientUnits="userSpaceOnUse" id="tile_1_" r="40.281">
            <stop offset="0" stopColor="#EC202B"/>
            <stop offset="0.146" stopColor="#E2202A"/>
            <stop offset="0.399" stopColor="#C51E26"/>
            <stop offset="0.726" stopColor="#981C20"/>
            <stop offset="1" stopColor="#6D1A1B"/>
          </radialGradient>
          <rect className="st0" height="24" id="tile" style={{fill: 'url(#tile_1_)'}} width="24"/>
        </g>
        <path className="st1" d="M12,7.7C10.9,8.6,9.5,9.4,8.1,10c0.2,1.4,0.2,3,0,4.4c1.4,0.5,2.6,1.3,3.8,2.2c1.2-0.9,2.6-1.6,3.9-2.2
          c-0.2-1.4-0.2-3,0-4.3C14.5,9.5,13.2,8.7,12,7.7z M16.7,14.4c1.2-0.5,2.4-0.9,3.7-1.1c0,0.1-0.1,0.7-0.1,0.8
          c-1.2,0.3-2.3,0.5-3.4,0.9c0.2,1.1,0.6,2.1,1,3.2l-0.7,0.5c-0.4-1.3-0.8-2.2-1-3.5c-1.4,0.6-2.5,0.9-3.7,1.9c0,0,1.9,1.9,2.7,2.8
          c-0.4,0.2-0.9,0.3-1.3,0.4c-0.6-0.7-1.3-1.3-2-1.9c-0.8,0.6-1.4,1.2-2,1.9C9.5,20.2,9,20,8.6,19.9c0.9-0.9,2.8-2.8,2.8-2.8
          c-1.3-0.9-2.3-1.5-3.8-2.1c-0.2,1.4-0.6,2.5-1,3.8c-0.1-0.1-0.5-0.4-0.6-0.4c0.4-1.1,0.8-2.2,1-3.4c-1.1-0.4-2.3-0.8-3.5-1
          c0-0.1,0-0.7,0-0.8c1.4,0.3,2.6,0.5,3.8,1.1c0.2-1.5,0.2-2.7,0-4.2c0,0-2.5,0.6-3.8,0.9c0.1-0.4,0.2-0.9,0.3-1.3
          c0.9-0.2,1.9-0.4,2.7-0.8C6.3,7.9,6.1,7,5.8,6.1c0.3-0.3,0.7-0.6,1-0.9c0.4,1.3,1,3.8,1,3.8c1.4-0.7,2.3-1.2,3.5-2.1
          C10.2,6,9.5,5.1,8.7,4.1C8.8,4,9.4,3.5,9.4,3.5c0.8,1,1.5,2,2.5,2.8c0.9-0.8,1.6-1.7,2.5-2.6c0.2,0,0.6,0.4,0.7,0.5
          c-0.9,1-1.5,1.9-2.6,2.7c1.3,0.9,2.2,1.6,3.6,2.3c0,0,0.6-2.6,1-3.9c0.4,0.3,0.7,0.6,0.9,0.9c-0.3,0.9-0.4,1.7-0.6,2.6
          c0.9,0.3,1.7,0.6,2.7,0.9c0.1,0.4,0.2,0.9,0.3,1.3c-1.3-0.3-3.7-1.2-3.7-1.2C16.7,11.4,16.5,12.9,16.7,14.4z" style={{fill: '#FFFFFF'}}/>
      </svg>
    </Icon>
  );
};

const AdobeExperiencePlatform = props => {
  return (
    <Icon {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.3922,6V18L17.568,15.21559a11.13343,11.13343,0,0,1-4.07637-4.078Z" fill="#f90025" />
        <path d="M22.3922,6l-8.90055,5.13763A11.118,11.118,0,0,1,11.9992,5.56881V0Z" fill="#8d0017" />
        <path d="M11.9992,0V5.57041a11.11212,11.11212,0,0,1-1.49244,5.56722L1.6078,6Z" fill="#c20020" />
        <path d="M10.50676,11.13763a11.13507,11.13507,0,0,1-4.06842,4.07319l-.008.00477L1.6078,18V6Z" fill="#f90025" />
        <path d="M22.3922,18l-10.393,6V13.72315A11.11661,11.11661,0,0,1,17.568,15.21559Z" fill="#c20020" />
        <path
          d="M11.9992,13.72315V24L1.6078,18l4.82259-2.78441A11.11655,11.11655,0,0,1,11.9992,13.72315Z"
          fill="#8d0017"
        />
      </svg>
    </Icon>
  );
};
/* eslint-enable max-len */

const iconMap = {
  AdobeAdvertisingCloud,
  AdobeAnalytics,
  AdobeAudienceManager,
  AdobeCampaign,
  AdobeExperienceCloud,
  AdobeExperienceManager,
  AdobeExperiencePlatform,
  AdobeMediaOptimizer,
  AdobePrimetime,
  AdobeTarget
};

export function getByName(iconName) {
  let icon = iconMap[iconName];
  if (!icon) {
    throw new Error(`Missing icon "${iconName}" from map. Try one of ${Object.keys(iconMap)}`);
  }
  return icon;
}
